/** Categories for News (super-admin + editor forms & filters) */
export const NEWS_CATEGORIES = [
  'Politics',
  'Community',
  'Technology',
  'Business',
  'Sports',
  'Entertainment',
  'Health',
  'Science',
  'World',
];

/** Categories for Blogs (super-admin + editor forms & filters) */
export const BLOG_CATEGORIES = [
  'Politics',
  'Community',
  'Technology',
  'Business',
  'Health',
  'Lifestyle',
  'Travel',
  'Food',
  'Education',
  'Entertainment',
];
